import { useAppDispatch, useAppSelector } from "@app/store";
import Notification from "@components/notification";
import { removeAlert } from "./slice";

export const AlertContainer = () => {
  const alerts = useAppSelector((state) => state.alert.alerts);
  const dispatch = useAppDispatch();

  return (
    <div style={{ position: "fixed", top: 0, right: 0, zIndex: 1000 }}>
      {alerts.map((notif) => (
        <Notification
          key={notif.id}
          id={notif.id}
          message={notif.message}
          remove={() => dispatch(removeAlert(notif.id))}
        />
      ))}
    </div>
  );
};
